import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import goodsAdd from './goodsAdd';
import { fetchCreate, fetchUpdate, fetchDetail } from '@/api/PMS/customerService/lostAndFound/queryList';
export default {
  components: {
    goodsAdd: goodsAdd
  },
  props: {
    keyValue: {
      type: Number,
      default: -1
    },
    showDialog: Boolean,
    isDetail: Boolean
  },
  data: function data() {
    return {
      rules: {
        title: [{
          required: true,
          message: '请输入失物招领标题',
          trigger: 'blur'
        }],
        pickUpUserName: [{
          required: true,
          message: '请输入拾取人姓名',
          trigger: 'blur'
        }],
        pickUpUserPhone: [{
          required: true,
          message: '请输入拾取人联系方式',
          trigger: 'blur'
        }],
        pickUpPlace: [{
          required: true,
          message: '请输入拾取地点',
          trigger: 'blur'
        }]
      },
      childData: {},
      previewData: {},
      goodsObj: {},
      isSend: false,
      isCheck: false,
      list: [],
      files: [],
      editIndex: 0,
      limit: 10,
      page: 1,
      optionsQuery: {
        page: 1,
        areaId: ''
      },
      title: '',
      adId: '',
      uploadUrl: '',
      downloadUrl: '',
      multipleSelection: [],
      isValidate: true,
      isUpdateGoods: false,
      dialogFormVisible: false,
      dialogAddFormVisible: false,
      corpIdOptions: [],
      options: [],
      classList: [],
      previewTitle: '',
      dialogImageUrl: '',
      dialogVisible: false,
      dialogPreviewVisible: false,
      previewVoucherNo: '',
      corpId: '',
      previewRemark: '',
      materialCategory: ''
    };
  },
  watch: {
    showDialog: function showDialog(n, o) {
      if (n) {
        this.$refs.dataForm.resetFields();
        this.init();
      }
    }
  },
  created: function created() {
    this.uploadUrl = process.env.VUE_APP_UPLOAD;
    this.downloadUrl = process.env.VUE_APP_DOWNLOAD;
    this.init();
  },
  methods: {
    init: function init() {
      var _this = this;

      this.list = [];
      this.files = [];
      this.$nextTick(function () {
        _this.$refs['dataForm'].clearValidate();
      });

      if (this.keyValue > 0) {
        var queryData = {
          id: this.keyValue
        };
        fetchDetail(queryData).then(function (res) {
          _this.childData = res.data.data;
          _this.list = _this.childData.goodsGoodsInfoList;

          _this.files.push({
            url: _this.childData.completeUrl,
            name: _this.childData.fileOrgName
          }); // this.dialogImageUrl = this.childData.completeUrl

        });
      } else {
        this.childData = {};
        this.isCheck = false;
      }
    },
    handleUpdate: function handleUpdate(obj, index) {
      this.editIndex = index;
      this.isCheck = false;
      this.isUpdateGoods = true;
      this.goodsObj = JSON.parse(JSON.stringify(obj));
      this.dialogFormVisible = true;
      this.previewTitle = '编辑';
    },
    handleCheck: function handleCheck(obj) {
      this.isCheck = true;
      this.goodsObj = JSON.parse(JSON.stringify(obj));
      this.dialogFormVisible = true;
      this.previewTitle = '详情';
    },
    handleDelete: function handleDelete(index) {
      var _this2 = this;

      console.log(index, 'index');
      console.log(this.list, 'index');
      this.$confirm('你确定是要删除该物品, 是否继续?', '提示').then(function () {
        _this2.list.splice(index, 1);

        console.log(_this2.list, 'alertType');

        _this2.Alert({
          alertType: 'delete'
        });
      });
    },
    handCanclePre: function handCanclePre() {
      this.dialogFormVisible = false;
    },
    receiveGoodsObj: function receiveGoodsObj(obj, isUpdate) {
      var _this3 = this;

      if (isUpdate) {
        this.list.splice(this.editIndex, 1);
      } else {
        this.list.forEach(function (item, index) {
          if (item.goodsName === obj.goodsName) {
            _this3.list.splice(index, 1);
          }
        });
      }

      this.list.push(JSON.parse(JSON.stringify(obj)));
      this.dialogFormVisible = false;
    },
    // 上传图片成功时获取服务器图片URL
    handleSuccess: function handleSuccess(response, file) {
      this.childData.photoUrlId = file.response.data[0].fileId;
    },
    handleError: function handleError(err, file) {
      var res = JSON.parse(err.message);
      this.$message({
        message: res.message,
        type: 'error'
      });
    },
    beforeUpload: function beforeUpload(file) {
      var isJPEG = file.type === 'image/jpeg';
      var isJPG = file.type === 'image/jpg';
      var isPNG = file.type === 'image/png';

      if (!(isJPEG || isPNG || isJPG)) {
        this.$message.error('上传图片只能是 JPG/JPEG/PNG 格式!');
      }

      return isJPG || isJPEG || isPNG;
    },
    handlePreview: function handlePreview(file) {
      console.log('file', file);

      if (file.response) {
        // 当还未保存到业务逻辑中时的预览图片
        if (file.name.includes('png') || file.name.includes('jpg') || file.name.includes('jpeg')) {
          // 当附件是图片的时候在线打开
          this.dialogVisible = true;
          this.dialogImageUrl = this.downloadUrl + file.response.data[0].fileId;
          console.log(this.dialogImageUrl, '123this.dialogImageUrl');
        }
      } else {
        // 当已保存到业务逻辑中时的预览图片
        this.dialogVisible = true;
        this.dialogImageUrl = file.url;
        console.log(this.dialogImageUrl, 'this.dialogImageUrl');
      }
    },
    handleExceed: function handleExceed() {
      this.$message.error('最多只能上传一张图片');
    },
    // 移除图片
    handleRemove: function handleRemove() {
      this.childData.photoUrlId = '';
      this.files = [];
    },
    // 下载文件
    handleDownload: function handleDownload(url, name) {
      var link = document.createElement('a');
      link.style.display = 'none';
      link.href = url;
      link.setAttribute('download', name);
      document.body.appendChild(link);
      link.click();
    },
    // 判断上传的文件类型，方便数据库保存
    judgeFileType: function judgeFileType(str) {
      if (str === 'image/png' || str === 'image/jpeg' || str === 'image/jpg') {
        return 2;
      } else {
        return 1;
      }
    },
    handleConfirm: function handleConfirm() {
      var _this4 = this;

      this.$refs['dataForm'].validate(function (valid) {
        if (valid) {
          if (!_this4.childData.photoUrlId) {
            _this4.Alert({
              alertType: 'valid',
              message: '请上传图片'
            });

            return;
          }

          if (_this4.list.length < 1) {
            _this4.Alert({
              alertType: 'valid',
              message: '拾取物品列表不能为空'
            });

            return;
          }

          _this4.childData.goodsList = _this4.list.map(function (item) {
            return {
              volunFileMsgs: item.photoList,
              goodsName: item.goodsName,
              goodsSpecial: item.goodsSpecial,
              goodsType: item.goodsType
            };
          });

          if (_this4.keyValue > 0) {
            fetchUpdate(_this4.childData).then(function () {
              _this4.$emit('handCancle', true);

              _this4.Alert({
                alertType: 'update'
              });
            });
          } else {
            fetchCreate(_this4.childData).then(function () {
              _this4.keyValue = -1;

              _this4.$emit('handCancle', true);

              _this4.Alert({
                alertType: 'add'
              });
            });
          }
        } else {
          _this4.Alert({
            alertType: 'valid'
          });
        }
      });
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 创建
    handleAdd: function handleAdd() {
      this.goodsObj = {};
      this.isUpdateGoods = false;
      this.dialogFormVisible = true;
      this.previewTitle = '添加';
    },
    handleDeletes: function handleDeletes() {
      var articleIds = [];
      this.multipleSelection.forEach(function (row) {
        articleIds.push(row.articleId);
      });
      this.delete(articleIds);
    },
    handCancle: function handCancle() {
      this.$emit('handCancle', true);
    }
  }
};